/**
 * utils/constants.ts
 *
 * Central application constants shared across multiple modules.
 * Created to centralize storage bucket identifiers and related path markers
 * so they are defined once and imported where needed.
 */

export const FORM_LOGOS_BUCKET = 'form-logos';

export const FORM_LOGOS_PUBLIC_MARKER = `/object/public/${FORM_LOGOS_BUCKET}/`;
